<template>
  <ForgotPassword></ForgotPassword>
</template>

<script>
import ForgotPassword from './components/ForgotPassword';

export default {
  components: {
    ForgotPassword
  },

  methods: {
    goBackToPreviousPage() {
      this.$router.go(-1);
    }
  }
};
</script>
